module.exports = "//static.hsappstatic.net/salesImages/static-1.403/onboarding/crm-features-full-horizontal.svg"